import { render } from "./001-yorick.vue?vue&type=template&id=2fd11a68"
import script from "./001-yorick.vue?vue&type=script&lang=js"
export * from "./001-yorick.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__